import React, {useContext} from 'react';

import {ButtonLink} from '../../../components/atoms/baseline/baseline';
import {AlertInfo} from '../../../components/molecules/baseline/baseline';

import Spinner from '../../atoms/Spinner/Spinner';
import RefundInfoContext from '../../context/RefundInfoContext';
import {ACTION_LOCATION} from '../../molecules/VaFloating/constants';
import translate from '../../../utils/translations';

import './RefundInfo.less';

export const RefundInfo = ({translations}) => {
    const {
        isLoading,
        showRefundInfo,
        updateActionLocation,
        updateChatWidgetCounter,
        updateIsLoading,
        updateRefundInfoFlag,
    } = useContext(RefundInfoContext);

    const openRefundVa = () => {
        updateIsLoading(true);
        updateActionLocation(ACTION_LOCATION.NOTIFICATION_SECTION);

        if (!showRefundInfo) {
            updateRefundInfoFlag();
        } else {
            updateChatWidgetCounter();
        }
    };

    return (
        <div className="RefundInfo">
            <AlertInfo
                msg={translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.details.refundInfo.description'
                )}
                subtle
                title={translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.details.refundInfo.title'
                )}
            >
                <div className="RefundInfo__BtnLink--wrapper">
                    <ButtonLink
                        disabled={isLoading}
                        label={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.details.refundInfo.button'
                        )}
                        onClick={openRefundVa}
                    />
                    <Spinner isLoading={isLoading} />
                </div>
            </AlertInfo>
        </div>
    );
};
